// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextArea_wrapper__2qVfJ","white":"TextArea_white__3G-C9"};